const lxUtils = {
  mounted() {
    this.sendPageView()
  },
  methods: {
    /**
     * @description pv上报
     * @param {string} cid
     */
    sendPageView(cid = this.cid) {
      if (!cid) return
      console.log('send', cid)
      window.LXAnalytics &&
        window.LXAnalytics(
          'pageView',
          {
            custom: {
              userName: this.userName,
              daxiang_mis_number: this.misId,
            },
          },
          null,
          cid
        )
    },
  },
  computed: {
    userName() {
      return window.__BIKE_POLARIS__.userName || ''
    },
    misId() {
      return window.__BIKE_POLARIS__.mis || ''
    },
  },
}

export default lxUtils
